import React from 'react'
import Board from './components/Board'
import './App.css'
const App = () => {
  return (
    <div>
    <h1> Welcome To My Tic-Tac-Toe Game</h1>
      <Board/>
    </div>
  )
}

export default App
